import { render, staticRenderFns } from "./CorridorAwarenessDetails.vue?vue&type=template&id=3963cc2c&scoped=true&"
import script from "./CorridorAwarenessDetails.vue?vue&type=script&lang=js&"
export * from "./CorridorAwarenessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963cc2c",
  null
  
)

export default component.exports